import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Package, Box } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobileItemDetailPage() {
  const { itemId } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [bom, setBom] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/items/${itemId}`).then(r => setItem(r.data)).catch(() => {}),
      axios.get(`${API}/items/${itemId}/bom`).then(r => setBom(r.data)).catch(() => {}),
    ]).finally(() => setLoading(false));
  }, [itemId]);

  if (loading) return <div className="mobile-page"><div className="mobile-loading"><div className="mobile-spinner" /></div></div>;
  if (!item) return <div className="mobile-page"><button className="mobile-back-btn" onClick={() => navigate(-1)}><ArrowLeft size={18} /> Back</button><div className="mobile-empty-state"><p>Item not found</p></div></div>;

  const components = bom?.components || [];

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate(-1)}><ArrowLeft size={18} /> Back</button>
      <div className="mobile-detail-section" style={{ textAlign: 'center', paddingTop: 20, paddingBottom: 20 }}>
        <div style={{ width: 48, height: 48, borderRadius: 12, background: '#ff9500', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 10px', color: 'white' }}><Package size={24} /></div>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#1c1c1e' }}>{item.name}</div>
        <div style={{ fontSize: 13, color: '#8e8e93', marginTop: 4 }}>{item.sku || 'N/A'} · {item.category || 'N/A'}</div>
      </div>
      <div className="mobile-kpi-row">
        <div className="mobile-kpi-card blue"><div className="mobile-kpi-label">On Hand</div><div className="mobile-kpi-value" style={{ fontSize: 20 }}>{item.on_hand || 0}</div></div>
        <div className="mobile-kpi-card green"><div className="mobile-kpi-label">Units/Case</div><div className="mobile-kpi-value" style={{ fontSize: 20 }}>{item.units_per_case || 'N/A'}</div></div>
      </div>
      <div className="mobile-detail-section">
        <div className="mobile-detail-section-title">Details</div>
        <div className="mobile-detail-row"><span className="mobile-detail-label">SKU</span><span className="mobile-detail-value">{item.sku || 'N/A'}</span></div>
        <div className="mobile-detail-row"><span className="mobile-detail-label">Category</span><span className="mobile-detail-value">{item.category || 'N/A'}</span></div>
        <div className="mobile-detail-row"><span className="mobile-detail-label">Unit</span><span className="mobile-detail-value">{item.unit || 'N/A'}</span></div>
        <div className="mobile-detail-row"><span className="mobile-detail-label">Type</span><span className="mobile-detail-value">{item.item_type || 'N/A'}</span></div>
        {item.description && <div className="mobile-detail-row"><span className="mobile-detail-label">Description</span><span className="mobile-detail-value" style={{ maxWidth: '60%', textAlign: 'right' }}>{item.description}</span></div>}
      </div>
      {components.length > 0 && (
        <div className="mobile-detail-section">
          <div className="mobile-detail-section-title">Bill of Materials ({components.length})</div>
          {components.map((c, i) => (
            <div key={i} className="mobile-detail-row">
              <span className="mobile-detail-label"><Box size={12} style={{ display: 'inline', verticalAlign: -1, marginRight: 4 }} />{c.component_name}</span>
              <span className="mobile-detail-value">{c.quantity} {c.unit}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
